import React, { Component } from 'react';
import { connect } from 'react-redux';
import uid from '../../../utils/generateUid';
import cloneDeep from 'lodash/cloneDeep';
import compact from 'lodash/compact';
import Error from './Error.jsx';
import TransitionGroup from 'react-transition-group/TransitionGroup'
import Transition from 'react-transition-group/Transition'
import anime from 'animejs';
import { inject, observer } from 'mobx-react'
//import setSplash from '../actions/setSplash';

class Errors extends Component {
  constructor(props) {
    super(props);
    this.state={errors:[]};
  }
  /*
  componentWillReceiveProps(nextProps) {
    if(nextProps.errors) {
      let errors=cloneDeep(this.state.errors);
      nextProps.errors.forEach((item)=>{
        if(item.code==='access_deny') {
          //this.props.setSplash({ type:'access_deny' });
        }
        errors.push({
          key:uid(),
          data:item,
        })
      });

      this.setState({
        errors:errors
      });

    }
  }
  */
  handleEnter(a) {
    a.style.height=0;
    a.style.opacity=0;
  }
  handleEntering(a) {
    const rect=a.children[0].getBoundingClientRect();
    anime({
      targets:[a],
      height:[0,rect.height],
      opacity:[0,1],
      duration:300,
      easing:'easeOutCubic',
    });
  }
  handleExiting(a) {
    const rect=a.children[0].getBoundingClientRect();
    anime({
      targets:[a],
      height:0,
      opacity:0,
      duration:300,
      easing:'easeOutCubic',
    });
  }
  renderErrors() {
    return this.props.appStateStore.global_errors.map((item,key)=>{
      return (
        <Transition
          onEnter={this.handleEnter}
          onEntering={this.handleEntering}
          onExiting={this.handleExiting}
          key={`trans-${item.uid}`}
          timeout={{ enter: 300, exit: 300 }}>
          <Error {...item} />
        </Transition>
      )
    });

    /*
    const errors= this.state.errors.map((item,key)=>{
      let func=(key)=>{
        let errors=cloneDeep(this.state.errors);
        delete errors[key];
        errors=compact(errors);
        this.setState({ errors:errors });
      };
      return (
        <Transition
          onEnter={this.handleEnter}
          onEntering={this.handleEntering}
          onExiting={this.handleExiting}
          key={`trans-${item.key}`}
          timeout={{ enter: 300, exit: 300 }}>
          <Error {...item} deleteMe={func.bind(this,key)} />
        </Transition>
      )
    });
    return errors;
     */

  }
  render() {
    return (
      <div className={`${this.props.static?'':'pf pa-tr'}`} style={{zIndex:200}}>
        <TransitionGroup>
          {this.props.appStateStore.global_errors.length ? this.renderErrors() : null}
        </TransitionGroup>
      </div>
    )
  }
}

function m(state) {
  return {
    errors:state.errors
  }
}

// export default connect(m,{ /*setSplash*/ })(Errors);
export default inject("appStateStore")(observer(Errors));